export const mobile_info_details = [
	{
		id: 23001,
		no: '2.3.1',
		label: 'อัตราส่วนจำนวนครั้งที่ค่า Round Trip Time (RTT) ต่ำกว่าที่กำหนด',
		targeted_text: 'เทคโนโลยี 3G ไม่น้อยกว่าร้อยละ 80 โดยกำหนดให้ RTT มีค่า 500 มิลลิวินาที',
		subLabel_1: 'เทคโนโลยี 3G ไม่น้อยกว่าร้อยละ 80 โดยกำหนดให้ RTT มีค่า 500 มิลลิวินาที',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 80,
		targetCondition: 'ge',
		filling_condition: 'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'D',
			'E',
			'F',
			'G'
		],
		excelValueRow: 12,
		priority: 202
	},
	{
		id: 23002,
		no: '2.3.1',
		label: '',
		targeted_text: '',
		subLabel_1: 'ค่าเฉลี่ย ms เทคโนโลยี 3G',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 0,
		targetCondition: 'ge',
		filling_condition: '',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'D',
			'E',
			'F',
			'G'
		],
		excelValueRow: 14,
		priority: 202.1
	},
	{
		id: 23003,
		no: '2.3.1',
		label: 'อัตราส่วนจำนวนครั้งที่ค่า Round Trip Time (RTT) ต่ำกว่าที่กำหนด',
		targeted_text: 'เทคโนโลยี 4G ไม่น้อยกว่าร้อยละ 80 โดยกำหนดให้ RTT มีค่า 150 มิลลิวินาที',
		subLabel_1: 'เทคโนโลยี 4G ไม่น้อยกว่าร้อยละ 80 โดยกำหนดให้ RTT มีค่า 150 มิลลิวินาที',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 80,
		targetCondition: 'ge',
		filling_condition: 'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'D',
			'E',
			'F',
			'G'
		],
		excelValueRow: 16,
		priority: 203
	},
	{
		id: 23004,
		no: '2.3.1',
		label: '',
		targeted_text: '',
		subLabel_1: 'ค่าเฉลี่ย ms เทคโนโลยี 4G',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 0,
		targetCondition: 'ge',
		filling_condition: '',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'D',
			'E',
			'F',
			'G'
		],
		excelValueRow: 18,
		priority: 203.1
	},
	{
		id: 23005,
		no: '2.3.1',
		label: 'อัตราส่วนจำนวนครั้งที่ค่า Round Trip Time (RTT) ต่ำกว่าที่กำหนด',
		targeted_text: 'เทคโนโลยี 5G (NSA และ SA ที่ไม่ใช้คลื่นความถี่ 2600 MHz) ไม่น้อยกว่าร้อยละ 80 โดยกำหนดให้ RTT มีค่า 150 มิลลิวินาที',
		subLabel_1: 'เทคโนโลยี 5G (NSA และ SA ที่ไม่ใช้คลื่นความถี่ 2600 MHz) ไม่น้อยกว่าร้อยละ 80 โดยกำหนดให้ RTT มีค่า 150 มิลลิวินาที',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 80,
		targetCondition: 'ge',
		filling_condition: 'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'D',
			'E',
			'F',
			'G'
		],
		excelValueRow: 20,
		priority: 203.3
	},
	{
		id: 23006,
		no: '2.3.1',
		label: '',
		targeted_text: '',
		subLabel_1: 'ค่าเฉลี่ย ms เทคโนโลยี 5G (NSA และ SA ที่ไม่ใช้คลื่นความถี่ 2600 MHz)',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 0,
		targetCondition: 'ge',
		filling_condition: '',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'D',
			'E',
			'F',
			'G'
		],
		excelValueRow: 22,
		priority: 203.4
	},
	{
		id: 23007,
		no: '2.3.1',
		label: 'อัตราส่วนจำนวนครั้งที่ค่า Round Trip Time (RTT) ต่ำกว่าที่กำหนด',
		targeted_text: 'เทคโนโลยี 5G (SA ที่ใช้คลื่นความถี่ 2600 MHz) ไม่น้อยกว่าร้อยละ 80 โดยกำหนดให้ RTT มีค่า 110 มิลลิวินาที',
		subLabel_1: 'เทคโนโลยี 5G (SA ที่ใช้คลื่นความถี่ 2600 MHz) ไม่น้อยกว่าร้อยละ 80 โดยกำหนดให้ RTT มีค่า 110 มิลลิวินาที',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 80,
		targetCondition: 'ge',
		filling_condition: 'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'D',
			'E',
			'F',
			'G'
		],
		excelValueRow: 24,
		priority: 203.5
	},
	{
		id: 23008,
		no: '2.3.1',
		label: '',
		targeted_text: '',
		subLabel_1: 'ค่าเฉลี่ย ms เทคโนโลยี 5G (SA ที่ใช้คลื่นความถี่ 2600 MHz)',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 0,
		targetCondition: 'ge',
		filling_condition: '',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'D',
			'E',
			'F',
			'G'
		],
		excelValueRow: 26,
		priority: 203.6
	},
	{
		id: 23009,
		no: '2.3.2',
		label: 'อัตราส่วนจำนวนครั้งที่รับส่งข้อมูลแบบ FTP ได้สำเร็จ(FTP success ratio)',
		targeted_text: 'เทคโนโลยี 3G ไม่น้อยกว่าร้อยละ 80 สำหรับกรณี Download',
		subLabel_1: 'เทคโนโลยี 3G ไม่น้อยกว่าร้อยละ 80 สำหรับกรณี Download',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 80,
		targetCondition: 'ge',
		filling_condition: 'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'D',
			'E',
			'F',
			'G'
		],
		excelValueRow: 29,
		priority: 204
	},
	{
		id: 23010,
		no: '2.3.2',
		label: 'อัตราส่วนจำนวนครั้งที่รับส่งข้อมูลแบบ FTP ได้สำเร็จ(FTP success ratio)',
		targeted_text: 'เทคโนโลยี 3G ไม่น้อยกว่าร้อยละ 70 สำหรับกรณี Upload',
		subLabel_1: 'เทคโนโลยี 3G ไม่น้อยกว่าร้อยละ 70 สำหรับกรณี Upload',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 70,
		targetCondition: 'ge',
		filling_condition: 'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'D',
			'E',
			'F',
			'G'
		],
		excelValueRow: 33,
		priority: 205
	},
	{
		id: 23011,
		no: '2.3.2',
		label: 'อัตราส่วนจำนวนครั้งที่รับส่งข้อมูลแบบ FTP ได้สำเร็จ(FTP success ratio)',
		targeted_text: 'เทคโนโลยี 4G ไม่น้อยกว่าร้อยละ 80 สำหรับกรณี Download',
		subLabel_1: 'เทคโนโลยี 4G ไม่น้อยกว่าร้อยละ 80 สำหรับกรณี Download',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 80,
		targetCondition: 'ge',
		filling_condition: 'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'D',
			'E',
			'F',
			'G'
		],
		excelValueRow: 37,
		priority: 206
	},
	{
		id: 23012,
		no: '2.3.2',
		label: 'อัตราส่วนจำนวนครั้งที่รับส่งข้อมูลแบบ FTP ได้สำเร็จ(FTP success ratio)',
		targeted_text: 'เทคโนโลยี 4G ไม่น้อยกว่าร้อยละ 70 สำหรับกรณี Upload',
		subLabel_1: 'เทคโนโลยี 4G ไม่น้อยกว่าร้อยละ 70 สำหรับกรณี Upload',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 70,
		targetCondition: 'ge',
		filling_condition: 'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'D',
			'E',
			'F',
			'G'
		],
		excelValueRow: 41,
		priority: 207
	},
	{
		id: 23013,
		no: '2.3.2',
		label: 'อัตราส่วนจำนวนครั้งที่รับส่งข้อมูลแบบ FTP ได้สำเร็จ(FTP success ratio)',
		targeted_text: 'เทคโนโลยี 5G (ที่ไม่ใช้คลื่นความถี่ 2600 MHz) ไม่น้อยกว่าร้อยละ 80 สำหรับกรณี Download',
		subLabel_1: 'เทคโนโลยี 5G (ที่ไม่ใช้คลื่นความถี่ 2600 MHz) ไม่น้อยกว่าร้อยละ 80 สำหรับกรณี Download',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 80,
		targetCondition: 'ge',
		filling_condition: 'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'D',
			'E',
			'F',
			'G'
		],
		excelValueRow: 45,
		priority: 207.2
	},
	{
		id: 23014,
		no: '2.3.2',
		label: 'อัตราส่วนจำนวนครั้งที่รับส่งข้อมูลแบบ FTP ได้สำเร็จ(FTP success ratio)',
		targeted_text: 'เทคโนโลยี 5G (ที่ไม่ใช้คลื่นความถี่ 2600 MHz) ไม่น้อยกว่าร้อยละ 70 สำหรับกรณี Upload',
		subLabel_1: 'เทคโนโลยี 5G (ที่ไม่ใช้คลื่นความถี่ 2600 MHz) ไม่น้อยกว่าร้อยละ 70 สำหรับกรณี Upload',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 70,
		targetCondition: 'ge',
		filling_condition: 'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'D',
			'E',
			'F',
			'G'
		],
		excelValueRow: 49,
		priority: 207.3
	},
	{
		id: 23015,
		no: '2.3.2',
		label: 'อัตราส่วนจำนวนครั้งที่รับส่งข้อมูลแบบ FTP ได้สำเร็จ(FTP success ratio)',
		targeted_text: 'เทคโนโลยี 5G (ที่ใช้คลื่นความถี่ 2600 MHz) ไม่น้อยกว่าร้อยละ 80 สำหรับกรณี Download',
		subLabel_1: 'เทคโนโลยี 5G (ที่ใช้คลื่นความถี่ 2600 MHz) ไม่น้อยกว่าร้อยละ 80 สำหรับกรณี Download',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 80,
		targetCondition: 'ge',
		filling_condition: 'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'D',
			'E',
			'F',
			'G'
		],
		excelValueRow: 53,
		priority: 207.4
	},
	{
		id: 23016,
		no: '2.3.2',
		label: 'อัตราส่วนจำนวนครั้งที่รับส่งข้อมูลแบบ FTP ได้สำเร็จ(FTP success ratio)',
		targeted_text: 'เทคโนโลยี 5G (ที่ใช้คลื่นความถี่ 2600 MHz) ไม่น้อยกว่าร้อยละ 70 สำหรับกรณี Upload',
		subLabel_1: 'เทคโนโลยี 5G (ที่ใช้คลื่นความถี่ 2600 MHz) ไม่น้อยกว่าร้อยละ 70 สำหรับกรณี Upload',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 70,
		targetCondition: 'ge',
		filling_condition: 'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'D',
			'E',
			'F',
			'G'
		],
		excelValueRow: 57,
		priority: 207.5
	},
	{
		id: 23017,
		no: '2.3.3',
		label: 'อัตราส่วนจำนวนครั้งที่รับส่งข้อมูลแบบ FTP ได้ไม่ต่ำกว่าอัตราบิตที่กำหนด (FTP ratio subjected to specified bit rate)',
		targeted_text: 'เทคโนโลยี 3G ไม่น้อยกว่าร้อยละ 75 โดยกำหนดให้อัตราบิต (Bitrate) มีค่า 750 กิโลบิตต่อวินาที สำหรับกรณี Download',
		subLabel_1: 'เทคโนโลยี 3G ไม่น้อยกว่าร้อยละ 75 โดยกำหนดให้อัตราบิต (Bitrate) มีค่า 750 กิโลบิตต่อวินาที สำหรับกรณี Download',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 75,
		targetCondition: 'ge',
		filling_condition: 'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'D',
			'E',
			'F',
			'G'
		],
		excelValueRow: 62,
		priority: 208
	},
	{
		id: 23018,
		no: '2.3.3',
		label: '',
		targeted_text: '',
		subLabel_1: 'ความเร็วเฉลี่ย (Mbps) เทคโนโลยี 3G สำหรับกรณี Download',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 0,
		targetCondition: 'ge',
		filling_condition: '',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'D',
			'E',
			'F',
			'G'
		],
		excelValueRow: 66,
		priority: 208.1
	},
	{
		id: 23019,
		no: '2.3.3',
		label: 'อัตราส่วนจำนวนครั้งที่รับส่งข้อมูลแบบ FTP ได้ไม่ต่ำกว่าอัตราบิตที่กำหนด (FTP ratio subjected to specified bit rate)',
		targeted_text: 'เทคโนโลยี 3G ไม่น้อยกว่าร้อยละ 75 โดยกำหนดให้อัตราบิต (Bitrate) มีค่า 300 กิโลบิตต่อวินาที สำหรับกรณี Upload',
		subLabel_1: 'เทคโนโลยี 3G ไม่น้อยกว่าร้อยละ 75 โดยกำหนดให้อัตราบิต (Bitrate) มีค่า 300 กิโลบิตต่อวินาที สำหรับกรณี Upload',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 75,
		targetCondition: 'ge',
		filling_condition: 'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'D',
			'E',
			'F',
			'G'
		],
		excelValueRow: 70,
		priority: 209
	},
	{
		id: 23020,
		no: '2.3.3',
		label: '',
		targeted_text: '',
		subLabel_1: 'ความเร็วเฉลี่ย (Mbps) เทคโนโลยี 3G สำหรับกรณี Upload',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 0,
		targetCondition: 'ge',
		filling_condition: '',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'D',
			'E',
			'F',
			'G'
		],
		excelValueRow: 74,
		priority: 209.1
	},
	{
		id: 23021,
		no: '2.3.3',
		label: 'อัตราส่วนจำนวนครั้งที่รับส่งข้อมูลแบบ FTP ได้ไม่ต่ำกว่าอัตราบิตที่กำหนด (FTP ratio subjected to specified bit rate)',
		targeted_text: 'เทคโนโลยี 4G ไม่น้อยกว่าร้อยละ 75 โดยกำหนดให้อัตราบิต (Bitrate) มีค่า 2.5 เมกะบิตต่อวินาที สำหรับกรณี Download',
		subLabel_1: 'เทคโนโลยี 4G ไม่น้อยกว่าร้อยละ 75 โดยกำหนดให้อัตราบิต (Bitrate) มีค่า 2.5 เมกะบิตต่อวินาที สำหรับกรณี Download',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 75,
		targetCondition: 'ge',
		filling_condition: 'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'D',
			'E',
			'F',
			'G'
		],
		excelValueRow: 78,
		priority: 210
	},
	{
		id: 23022,
		no: '2.3.3',
		label: '',
		targeted_text: '',
		subLabel_1: 'ความเร็วเฉลี่ย (Mbps) เทคโนโลยี 4G สำหรับกรณี Download',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 0,
		targetCondition: 'ge',
		filling_condition: '',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'D',
			'E',
			'F',
			'G'
		],
		excelValueRow: 82,
		priority: 210.1
	},
	{
		id: 23023,
		no: '2.3.3',
		label: 'อัตราส่วนจำนวนครั้งที่รับส่งข้อมูลแบบ FTP ได้ไม่ต่ำกว่าอัตราบิตที่กำหนด (FTP ratio subjected to specified bit rate)',
		targeted_text: 'เทคโนโลยี 4G ไม่น้อยกว่าร้อยละ 75 โดยกำหนดให้อัตราบิต (Bitrate) มีค่า 500 กิโลบิตต่อวินาที สำหรับกรณี Upload',
		subLabel_1: 'เทคโนโลยี 4G ไม่น้อยกว่าร้อยละ 75 โดยกำหนดให้อัตราบิต (Bitrate) มีค่า 500 กิโลบิตต่อวินาที สำหรับกรณี Upload',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 75,
		targetCondition: 'ge',
		filling_condition: 'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'D',
			'E',
			'F',
			'G'
		],
		excelValueRow: 86,
		priority: 211
	},
	{
		id: 23024,
		no: '2.3.3',
		label: '',
		targeted_text: '',
		subLabel_1: 'ความเร็วเฉลี่ย (Mbps) เทคโนโลยี 4G สำหรับกรณี Upload',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 0,
		targetCondition: 'ge',
		filling_condition: '',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'D',
			'E',
			'F',
			'G'
		],
		excelValueRow: 90,
		priority: 211.1
	},
	{
		id: 23025,
		no: '2.3.3',
		label: 'อัตราส่วนจำนวนครั้งที่รับส่งข้อมูลแบบ FTP ได้ไม่ต่ำกว่าอัตราบิตที่กำหนด (FTP ratio subjected to specified bit rate)',
		targeted_text: 'เทคโนโลยี 5G (ที่ไม่ใช้คลื่นความถี่ 2600 MHz) ไม่น้อยกว่าร้อยละ 75 โดยกำหนดให้อัตราบิต (Bitrate) มีค่า 2.5 เมกะบิตต่อวินาที สำหรับกรณี Download',
		subLabel_1: 'เทคโนโลยี 5G (ที่ไม่ใช้คลื่นความถี่ 2600 MHz) ไม่น้อยกว่าร้อยละ 75 โดยกำหนดให้อัตราบิต (Bitrate) มีค่า 2.5 เมกะบิตต่อวินาที สำหรับกรณี Download',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 75,
		targetCondition: 'ge',
		filling_condition: 'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'D',
			'E',
			'F',
			'G'
		],
		excelValueRow: 94,
		priority: 211.3
	},
	{
		id: 23026,
		no: '2.3.3',
		label: '',
		targeted_text: '',
		subLabel_1: 'ความเร็วเฉลี่ย (Mbps) เทคโนโลยี 5G (ที่ไม่ใช้คลื่นความถี่ 2600 MHz) สำหรับกรณี Download',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 0,
		targetCondition: 'ge',
		filling_condition: '',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'D',
			'E',
			'F',
			'G'
		],
		excelValueRow: 98,
		priority: 211.4
	},
	{
		id: 23027,
		no: '2.3.3',
		label: 'อัตราส่วนจำนวนครั้งที่รับส่งข้อมูลแบบ FTP ได้ไม่ต่ำกว่าอัตราบิตที่กำหนด (FTP ratio subjected to specified bit rate)',
		targeted_text: 'เทคโนโลยี 5G (ที่ไม่ใช้คลื่นความถี่ 2600 MHz) ไม่น้อยกว่าร้อยละ 75 โดยกำหนดให้อัตราบิต (Bitrate) มีค่า 500 กิโลบิตต่อวินาที สำหรับกรณี Upload',
		subLabel_1: 'เทคโนโลยี 5G (ที่ไม่ใช้คลื่นความถี่ 2600 MHz) ไม่น้อยกว่าร้อยละ 75 โดยกำหนดให้อัตราบิต (Bitrate) มีค่า 500 กิโลบิตต่อวินาที สำหรับกรณี Upload',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 75,
		targetCondition: 'ge',
		filling_condition: 'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'D',
			'E',
			'F',
			'G'
		],
		excelValueRow: 102,
		priority: 211.5
	},
	{
		id: 23028,
		no: '2.3.3',
		label: '',
		targeted_text: '',
		subLabel_1: 'ความเร็วเฉลี่ย (Mbps) เทคโนโลยี 5G (ที่ไม่ใช้คลื่นความถี่ 2600 MHz) สำหรับกรณี Upload',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 0,
		targetCondition: 'ge',
		filling_condition: '',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'D',
			'E',
			'F',
			'G'
		],
		excelValueRow: 106,
		priority: 211.6
	},
	{
		id: 23029,
		no: '2.3.3',
		label: 'อัตราส่วนจำนวนครั้งที่รับส่งข้อมูลแบบ FTP ได้ไม่ต่ำกว่าอัตราบิตที่กำหนด (FTP ratio subjected to specified bit rate)',
		targeted_text: 'เทคโนโลยี 5G (ที่ใช้คลื่นความถี่ 2600 MHz) ไม่น้อยกว่าร้อยละ 75 โดยกำหนดให้อัตราบิต (Bitrate) มีค่า 5 เมกะบิตต่อวินาที สำหรับกรณี Download',
		subLabel_1: 'เทคโนโลยี 5G (ที่ใช้คลื่นความถี่ 2600 MHz) ไม่น้อยกว่าร้อยละ 75 โดยกำหนดให้อัตราบิต (Bitrate) มีค่า 5 เมกะบิตต่อวินาที สำหรับกรณี Download',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 75,
		targetCondition: 'ge',
		filling_condition: 'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'D',
			'E',
			'F',
			'G'
		],
		excelValueRow: 110,
		priority: 211.7
	},
	{
		id: 23030,
		no: '2.3.3',
		label: '',
		targeted_text: '',
		subLabel_1: 'ความเร็วเฉลี่ย (Mbps) เทคโนโลยี 5G (ที่ไม่ใช้คลื่นความถี่ 2600 MHz) สำหรับกรณี Download',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 0,
		targetCondition: 'ge',
		filling_condition: '',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'D',
			'E',
			'F',
			'G'
		],
		excelValueRow: 114,
		priority: 211.8
	},
	{
		id: 23031,
		no: '2.3.3',
		label: 'อัตราส่วนจำนวนครั้งที่รับส่งข้อมูลแบบ FTP ได้ไม่ต่ำกว่าอัตราบิตที่กำหนด (FTP ratio subjected to specified bit rate)',
		targeted_text: 'เทคโนโลยี 5G (ที่ใช้คลื่นความถี่ 2600 MHz) ไม่น้อยกว่าร้อยละ 75 โดยกำหนดให้อัตราบิต (Bitrate) มีค่า 1.25 เมกะบิตต่อวินาที สำหรับกรณี Upload',
		subLabel_1: 'เทคโนโลยี 5G (ที่ใช้คลื่นความถี่ 2600 MHz) ไม่น้อยกว่าร้อยละ 75 โดยกำหนดให้อัตราบิต (Bitrate) มีค่า 1.25 เมกะบิตต่อวินาที สำหรับกรณี Upload',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 75,
		targetCondition: 'ge',
		filling_condition: 'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'D',
			'E',
			'F',
			'G'
		],
		excelValueRow: 118,
		priority: 211.9
	},
	{
		id: 23032,
		no: '2.3.3',
		label: '',
		targeted_text: '',
		subLabel_1: 'ความเร็วเฉลี่ย (Mbps) เทคโนโลยี 5G (ที่ใช้คลื่นความถี่ 2600 MHz) สำหรับกรณี Upload',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 0,
		targetCondition: 'ge',
		filling_condition: '',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'D',
			'E',
			'F',
			'G'
		],
		excelValueRow: 122,
		priority: 211.91
	},
	{
		id: 23033,
		no: '2.3.4',
		label: 'อัตราส่วนจำนวนครั้งที่ HTTP โหลดได้ไม่ต่ำกว่าเวลาที่กำหนด (HTTP ratio subjected to specified time duration)',
		targeted_text: 'เทคโนโลยี 3G ไม่น้อยกว่าร้อยละ 90 โดยมีเวลาที่กำหนดเท่ากับ 3 นาที',
		subLabel_1: 'เทคโนโลยี 3G ไม่น้อยกว่าร้อยละ 90 โดยมีเวลาที่กำหนดเท่ากับ 3 นาที',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 90,
		targetCondition: 'ge',
		filling_condition: 'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'D',
			'E',
			'F',
			'G'
		],
		excelValueRow: 131,
		priority: 213
	},
	{
		id: 23034,
		no: '2.3.4',
		label: '',
		targeted_text: '',
		subLabel_1: 'ค่าเฉลี่ย ms เทคโนโลยี 3G',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 0,
		targetCondition: 'ge',
		filling_condition: '',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'D',
			'E',
			'F',
			'G'
		],
		excelValueRow: 133,
		priority: 213.1
	},
	{
		id: 23035,
		no: '2.3.4',
		label: 'อัตราส่วนจำนวนครั้งที่ HTTP โหลดได้ไม่ต่ำกว่าเวลาที่กำหนด (HTTP ratio subjected to specified time duration)',
		targeted_text: 'เทคโนโลยี 4G ไม่น้อยกว่าร้อยละ 90 โดยมีเวลาที่กำหนดเท่ากับ 1 นาที',
		subLabel_1: 'เทคโนโลยี 4G ไม่น้อยกว่าร้อยละ 90 โดยมีเวลาที่กำหนดเท่ากับ 1 นาที',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 90,
		targetCondition: 'ge',
		filling_condition: 'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'D',
			'E',
			'F',
			'G'
		],
		excelValueRow: 135,
		priority: 214
	},
	{
		id: 23036,
		no: '2.3.4',
		label: '',
		targeted_text: '',
		subLabel_1: 'ค่าเฉลี่ย ms เทคโนโลยี 4G',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 0,
		targetCondition: 'ge',
		filling_condition: '',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'D',
			'E',
			'F',
			'G'
		],
		excelValueRow: 137,
		priority: 214.1
	},
	{
		id: 23037,
		no: '2.3.4',
		label: 'อัตราส่วนจำนวนครั้งที่ HTTP โหลดได้ไม่ต่ำกว่าเวลาที่กำหนด (HTTP ratio subjected to specified time duration)',
		targeted_text: 'เทคโนโลยี 5G (NSA และ SA ที่ไม่ใช้คลื่นความถี่ 2600 MHz) ไม่น้อยกว่าร้อยละ 90 โดยมีเวลาที่กำหนดเท่ากับ 1 นาที',
		subLabel_1: 'เทคโนโลยี 5G (NSA และ SA ที่ไม่ใช้คลื่นความถี่ 2600 MHz) ไม่น้อยกว่าร้อยละ 90 โดยมีเวลาที่กำหนดเท่ากับ 1 นาที',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 90,
		targetCondition: 'ge',
		filling_condition: 'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'D',
			'E',
			'F',
			'G'
		],
		excelValueRow: 139,
		priority: 214.3
	},
	{
		id: 23038,
		no: '2.3.4',
		label: '',
		targeted_text: '',
		subLabel_1: 'ค่าเฉลี่ย ms เทคโนโลยี 5G (NSA และ SA ที่ไม่ใช้คลื่นความถี่ 2600 MHz)',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 0,
		targetCondition: 'ge',
		filling_condition: '',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'D',
			'E',
			'F',
			'G'
		],
		excelValueRow: 141,
		priority: 214.4
	},
	{
		id: 23039,
		no: '2.3.4',
		label: 'อัตราส่วนจำนวนครั้งที่ HTTP โหลดได้ไม่ต่ำกว่าเวลาที่กำหนด (HTTP ratio subjected to specified time duration)',
		targeted_text: 'เทคโนโลยี 5G (SA ที่ใช้คลื่นความถี่ 2600 MHz) ไม่น้อยกว่าร้อยละ 90 โดยมีเวลาที่กำหนดเท่ากับ 25 วินาที',
		subLabel_1: 'เทคโนโลยี 5G (SA ที่ใช้คลื่นความถี่ 2600 MHz) ไม่น้อยกว่าร้อยละ 90 โดยมีเวลาที่กำหนดเท่ากับ 25 วินาที',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 90,
		targetCondition: 'ge',
		filling_condition: 'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'D',
			'E',
			'F',
			'G'
		],
		excelValueRow: 143,
		priority: 214.5
	},
	{
		id: 23040,
		no: '2.3.4',
		label: '',
		targeted_text: '',
		subLabel_1: 'ค่าเฉลี่ย ms เทคโนโลยี 5G (SA ที่ใช้คลื่นความถี่ 2600 MHz)',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 0,
		targetCondition: 'ge',
		filling_condition: '',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'D',
			'E',
			'F',
			'G'
		],
		excelValueRow: 145,
		priority: 214.6
	},
	{
		id: 23041,
		no: '2.3.5',
		label: 'อัตราส่วนจำนวนครั้งที่สามารถเข้าถึงบริการสตรีมมิ่ง (Streaming service accessibility)',
		targeted_text: 'เทคโนโลยี 3G (Resolution 360p) ไม่น้อยกว่าร้อยละ 80',
		subLabel_1: 'เทคโนโลยี 3G (Resolution 360p) ไม่น้อยกว่าร้อยละ 80',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 80,
		targetCondition: 'ge',
		filling_condition: 'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'E',
			'F'
		],
		excelValueRow: 148,
		priority: 215
	},
	{
		id: 23042,
		no: '2.3.5',
		label: 'อัตราส่วนจำนวนครั้งที่สามารถเข้าถึงบริการสตรีมมิ่ง (Streaming service accessibility)',
		targeted_text: 'เทคโนโลยี 4G (Resolution 720p) ไม่น้อยกว่าร้อยละ 85',
		subLabel_1: 'เทคโนโลยี 4G (Resolution 720p) ไม่น้อยกว่าร้อยละ 85',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 85,
		targetCondition: 'ge',
		filling_condition: 'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'E',
			'F'
		],
		excelValueRow: 152,
		priority: 216
	},
	{
		id: 23043,
		no: '2.3.5',
		label: 'อัตราส่วนจำนวนครั้งที่สามารถเข้าถึงบริการสตรีมมิ่ง (Streaming service accessibility)',
		targeted_text: 'เทคโนโลยี 5G (NSA และ SA ที่ไม่ใช้คลื่นความถี่ 2600 MHz Resolution 720p) ไม่น้อยกว่าร้อยละ 85',
		subLabel_1: 'เทคโนโลยี 5G (NSA และ SA ที่ไม่ใช้คลื่นความถี่ 2600 MHz Resolution 720p) ไม่น้อยกว่าร้อยละ 85',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 85,
		targetCondition: 'ge',
		filling_condition: 'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'E',
			'F'
		],
		excelValueRow: 156,
		priority: 216.2
	},
	{
		id: 23044,
		no: '2.3.5',
		label: 'อัตราส่วนจำนวนครั้งที่สามารถเข้าถึงบริการสตรีมมิ่ง (Streaming service accessibility)',
		targeted_text: 'เทคโนโลยี 5G (SA ที่ใช้คลื่นความถี่ 2600 MHz Resolution 1080p) ไม่น้อยกว่าร้อยละ 90',
		subLabel_1: 'เทคโนโลยี 5G (SA ที่ใช้คลื่นความถี่ 2600 MHz Resolution 1080p) ไม่น้อยกว่าร้อยละ 90',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 90,
		targetCondition: 'ge',
		filling_condition: 'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'E',
			'F'
		],
		excelValueRow: 160,
		priority: 216.3
	},
	{
		id: 23045,
		no: '2.3.6',
		label: 'อัตราส่วนจำนวนครั้งการแสดงวีดีทัศน์แบบสตรีมมิ่งได้อย่างสมบูรณ์ (Streaming reproduction success ratio)',
		targeted_text: 'เทคโนโลยี 3G (Resolution 360p) ไม่น้อยกว่าร้อยละ 80',
		subLabel_1: 'เทคโนโลยี 3G (Resolution 360p) ไม่น้อยกว่าร้อยละ 80',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 80,
		targetCondition: 'ge',
		filling_condition: 'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'E',
			'F'
		],
		excelValueRow: 165,
		priority: 217
	},
	{
		id: 23046,
		no: '2.3.6',
		label: 'อัตราส่วนจำนวนครั้งการแสดงวีดีทัศน์แบบสตรีมมิ่งได้อย่างสมบูรณ์ (Streaming reproduction success ratio)',
		targeted_text: 'เทคโนโลยี 4G (Resolution 720p) ไม่น้อยกว่าร้อยละ 85',
		subLabel_1: 'เทคโนโลยี 4G (Resolution 720p) ไม่น้อยกว่าร้อยละ 85',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 85,
		targetCondition: 'ge',
		filling_condition: 'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'E',
			'F'
		],
		excelValueRow: 169,
		priority: 218
	},
	{
		id: 23047,
		no: '2.3.6',
		label: 'อัตราส่วนจำนวนครั้งการแสดงวีดีทัศน์แบบสตรีมมิ่งได้อย่างสมบูรณ์ (Streaming reproduction success ratio)',
		targeted_text: 'เทคโนโลยี 5G (NSA และ SA ที่ไม่ใช้คลื่นความถี่ 2600 MHz Resolution 720p) ไม่น้อยกว่าร้อยละ 85',
		subLabel_1: 'เทคโนโลยี 5G (NSA และ SA ที่ไม่ใช้คลื่นความถี่ 2600 MHz Resolution 720p) ไม่น้อยกว่าร้อยละ 85',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 85,
		targetCondition: 'ge',
		filling_condition: 'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'E',
			'F'
		],
		excelValueRow: 173,
		priority: 218.2
	},
	{
		id: 23048,
		no: '2.3.6',
		label: 'อัตราส่วนจำนวนครั้งการแสดงวีดีทัศน์แบบสตรีมมิ่งได้อย่างสมบูรณ์ (Streaming reproduction success ratio)',
		targeted_text: 'เทคโนโลยี 5G (SA ที่ใช้คลื่นความถี่ 2600 MHz Resolution 1080p) ไม่น้อยกว่าร้อยละ 90',
		subLabel_1: 'เทคโนโลยี 5G (SA ที่ใช้คลื่นความถี่ 2600 MHz Resolution 1080p) ไม่น้อยกว่าร้อยละ 90',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 90,
		targetCondition: 'ge',
		filling_condition: 'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'E',
			'F'
		],
		excelValueRow: 177,
		priority: 218.3
	},
	{
		id: 23049,
		no: '2.3.6/1',
		label: 'อัตราส่วนระยะเวลาที่การแสดงวีดีทัศน์แบบสตรีมิงไม่เคลื่อนไหว (Video freezing time proportion)',
		targeted_text: 'เทคโนโลยี 3G (Resolution 360p) ไม่เกินร้อยละ 5',
		subLabel_1: 'เทคโนโลยี 3G (Resolution 360p) ไม่เกินร้อยละ 5',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 5,
		targetCondition: 'le',
		filling_condition: 'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'E',
			'F'
		],
		excelValueRow: 181,
		priority: 219
	},
	{
		id: 23050,
		no: '2.3.6/1',
		label: 'อัตราส่วนระยะเวลาที่การแสดงวีดีทัศน์แบบสตรีมิงไม่เคลื่อนไหว (Video freezing time proportion)',
		targeted_text: 'เทคโนโลยี 4G (Resolution 720p) ไม่เกินร้อยละ 5',
		subLabel_1: 'เทคโนโลยี 4G (Resolution 720p) ไม่เกินร้อยละ 5',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 5,
		targetCondition: 'le',
		filling_condition: 'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'E',
			'F'
		],
		excelValueRow: 185,
		priority: 220
	},
	{
		id: 23051,
		no: '2.3.6/1',
		label: 'อัตราส่วนระยะเวลาที่การแสดงวีดีทัศน์แบบสตรีมิงไม่เคลื่อนไหว (Video freezing time proportion)',
		targeted_text: 'เทคโนโลยี 5G (NSA และ SA ที่ไม่ใช้คลื่นความถี่ 2600 MHz Resolution 720p) ไม่เกินร้อยละ 5',
		subLabel_1: 'เทคโนโลยี 5G (NSA และ SA ที่ไม่ใช้คลื่นความถี่ 2600 MHz Resolution 720p) ไม่เกินร้อยละ 5',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 5,
		targetCondition: 'le',
		filling_condition: 'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'E',
			'F'
		],
		excelValueRow: 189,
		priority: 221
	},
	{
		id: 23052,
		no: '2.3.6/1',
		label: 'อัตราส่วนระยะเวลาที่การแสดงวีดีทัศน์แบบสตรีมิงไม่เคลื่อนไหว (Video freezing time proportion)',
		targeted_text: 'เทคโนโลยี 5G (SA ที่ใช้คลื่นความถี่ 2600 MHz Resolution 1080p) ไม่เกินร้อยละ 5',
		subLabel_1: 'เทคโนโลยี 5G (SA ที่ใช้คลื่นความถี่ 2600 MHz Resolution 1080p) ไม่เกินร้อยละ 5',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 5,
		targetCondition: 'le',
		filling_condition: 'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'E',
			'F'
		],
		excelValueRow: 193,
		priority: 222
	},
	{
		id: 23053,
		no: '2.3.11',
		label: 'ค่าอัตราบิตเฉลี่ยของการรับส่งข้อมูลแบบ FTP (Average FTP Bitrate)',
		targeted_text: 'เทคโนโลยี 5G ที่ใช้คลื่นความถี่ย่าน 2600 MHz ไม่น้อยกว่า 20 เมกะบิตต่อวินาที สำหรับกรณี Download',
		subLabel_1: 'เทคโนโลยี 5G ที่ใช้คลื่นความถี่ย่าน 2600 MHz ไม่น้อยกว่า 20 เมกะบิตต่อวินาที สำหรับกรณี Download',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 20,
		targetCondition: 'ge',
		filling_condition: 'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นทศนิยม',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'D',
			'E',
			'F',
			'G'
		],
		excelValueRow: 198,
		priority: 223.1
	},
	{
		id: 23054,
		no: '2.3.11',
		label: 'ค่าอัตราบิตเฉลี่ยของการรับส่งข้อมูลแบบ FTP (Average FTP Bitrate)',
		targeted_text: 'เทคโนโลยี 5G ที่ใช้คลื่นความถี่ย่าน 2600 MHz ไม่น้อยกว่า 5 เมกะบิตต่อวินาที สำหรับกรณี Upload',
		subLabel_1: 'เทคโนโลยี 5G ที่ใช้คลื่นความถี่ย่าน 2600 MHz ไม่น้อยกว่า 5 เมกะบิตต่อวินาที สำหรับกรณี Upload',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 5,
		targetCondition: 'ge',
		filling_condition: 'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นทศนิยม',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null
		},
		data_type: 'float',
		excelValueCol: [
			'D',
			'E',
			'F',
			'G'
		],
		excelValueRow: 202,
		priority: 223.2
	}
]